import './TrustedBy.css';

const px = 10;
const brands = (
<>
    <li class='brand'>
        <a href="https://crapeyewear.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/crap.png' alt="crap eyewear logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://shopflavcity.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/flavcity.png' alt="flav city logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://theouai.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/ouai.png' alt="ouai logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://lunya.co" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/lunya.png' alt="lunya logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://686.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/686.png' alt="686 logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://kosas.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/kosas.png' alt="kosas logo"/>
        </a>
    </li> 
    <li class='brand'>
        <a href="https://parksproject.us" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/parks.png' alt="parks project logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://welcomeskateboards.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/welcome.png' alt="welcome logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://matteroffact.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/mof.png' alt="matter of fact skincare logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://saje.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/saje.png' alt="saje natural wellness logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://jot.co" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/jot.png' alt="jot coffee logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://negativeunderwear.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/negative.png' alt="negative underwear logo"/>
        </a>
    </li>
    <li class='brand'>
        <a href="https://cometskateboards.com" target="_blank" rel="noreferrer" >
            <img class="w-[100%]" src='/brands/comet.png' alt="comet skateboards logo"/>
        </a>
    </li>
</>
);


// we render the brands html twice so that the scroll loops around infinitely
function TrustedBy() {
    return(
        <div class='py-5 overflow-x-hidden bg-gray-100'>
            <div>
                <h3 class='text-md font-bold text-center'>CURRENT & PAST CLIENTS</h3>
            </div>
            <ul class='flex flex-shrink-0 items-center animate-scroll my-4'>
                {brands}
                {brands}
            </ul>
        </div>
    );
};

export default TrustedBy;